import { OptionTranslations } from '../models/option-translation.model';

export const OPTION_TRANSLATIONS: any = {
  nationalities: [
    { value: 'AE', en: 'UAE', ar: 'الإمارات' },
    { value: 'IN', en: 'Indian', ar: 'هندي' },
    { value: 'SA', en: 'Saudi', ar: 'سعودي' },
    { value: 'OT', en: 'Other', ar: 'أخرى' },

  ],
  roles: [
    { value: 'Shares Owner', en: 'Owner/Partner', ar: 'مالك / شريك' },
    { value: 'Manager', en: 'Manager', ar: 'مدير' },
    { value: 'Authorised Signatory', en: 'Authorised signatory', ar: 'مخول بالتوقيع' },
  ],
  partnerTypes: [
    { value: 'Individual', en: 'Individual', ar: 'فرد' },
    { value: 'Company', en: 'Company', ar: 'شركة' },
  ],
  standardOption: [
    { value: 'Yes', en: 'Yes', ar: 'نعم' },
    { value: 'No', en: 'No', ar: 'لا' },
  ],
  tyeOfAddUser: [
    { value: 'Myself', en: 'Add Myself', ar: 'أضف نفسي' },
    { value: 'New profile', en: 'Add a new profile', ar: 'إضافة ملف شخصي جديد' },
  ],
  membershipYearsList: [
    { value: '1', en: '1 Year', ar: 'سنة واحدة' },
    { value: '2', en: '2 Years', ar: 'سنتان' },
    { value: '3', en: '3 Years', ar: 'ثلاث سنوات' },
    { value: '4', en: '4 Years', ar: 'أربع سنوات' },
    { value: '5', en: '5 Years', ar: 'خمس سنوات' },
    { value: '6', en: '6 Years', ar: 'ست سنوات' },
    { value: '7', en: '7 Years', ar: 'سبع سنوات' },
    { value: '8', en: '8 Years', ar: 'ثماني سنوات' },
    { value: '9', en: '9 Years', ar: 'تسع سنوات' },
    { value: '10', en: '10 Years', ar: 'عشر سنوات' },
    { value: '11', en: '11 Years', ar: 'إحدى عشرة سنة' },
    { value: '12', en: '12 Years', ar: 'اثنتا عشرة سنة' },
    { value: '13', en: '13 Years', ar: 'ثلاث عشرة سنة' },
    { value: '14', en: '14 Years', ar: 'أربع عشرة سنة' },
    { value: '15', en: '15 Years', ar: 'خمس عشرة سنة' },
    { value: '16', en: '16 Years', ar: 'ست عشرة سنة' },
    { value: '17', en: '17 Years', ar: 'سبع عشرة سنة' },
    { value: '18', en: '18 Years', ar: 'ثماني عشرة سنة' },
    { value: '19', en: '19 Years', ar: 'تسع عشرة سنة' },
    { value: '20', en: '20 Years', ar: 'عشرون سنة'}
  ],

  applicationDays: [
    { "en": "Last 7 days", "ar": "آخر 7 أيام", "value": "7" },
    { "en": "Last 15 days", "ar": "آخر 15 يومًا", "value": "15" },
    { "en": "Last 30 days", "ar": "آخر 30 يومًا", "value": "30" }
  ],
  stampPositions: [
    { "en": "Left corner", "ar": 'الزاوية اليسرى', "value": "L" },
    { "en": "Center of the page", "ar": 'منتصف الصفحة', "value": "C" },
    { "en": "Right corner", "ar": 'الزاوية اليمنى', "value": "R" }
  ],

  svs_enquiryTypes: [{
    "en": "Certificate Amendment",
    "ar": "تعديل الشهادة",
    "value": "Certificate Amendment"
  },
  {
    "en": "To whom it may concern",
    "ar": "إلى من يهمه الأمر",
    "value": "To whom it may concern"
  },
  {
    "en": "Company Profile",
    "ar": "الملف التعريفي للشركة",
    "value": "Company Profile"
  }],
  info_marketingForm: [
    {
      value: 'Certificate-1',
      en: 'Certificate-1',
      ar: 'الشهادة الأولى'
    },
    {
      value: 'Certificate-2',
      en: 'Certificate-2',
      ar: 'الشهادة الثانية'
    }
  ],
  ResourceCategories: [
    {
      "en": "Laws",
      "ar": "القوانين",
      "value": "Laws"
    },
    {
      "en": "Reports",
      "ar": "التقارير",
      "value": "Reports"
    },
    {
      "en": "Service Manual",
      "ar": "دليل الخدمة",
      "value": "Service Manual"
    },
    {
      "en": "Instruction Videos",
      "ar": "فيديوهات إرشادية",
      "value": "Instruction Videos"
    },
    {
      "en": "Annual Reports",
      "ar": 'التقارير السنوية',
      "value": "Annual Reports"
    },
    {
      "en": "Knowledge Hub",
      "ar": 'مركز المعرفة',
      "value": "Knowledge Hub"
    },
    {
      "en": "Other",
      "ar": "أخرى",
      "value": "Other"
    }
  ]
};
